var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var editor_2d = require("editor-2d");
var colors = require("./../../../colors/colors.js");

/**
 * Created with JetBrains RubyMine.
 * User: kbruneel
 * Date: 6/27/13
 * Time: 2:08 PM
 */

var ArcCenterHandleView = function (gui, arcHandleModel, parentGroup, layers) {
    var self = this;
    this.gui = gui;
    this.arcHandleModel = arcHandleModel;
    console.assert(this.arcHandleModel);
    this.segmentModel = this.arcHandleModel.segmentModel;
    this.pointHandleModel = this.arcHandleModel.pointHandleModel;
    this.pathInteractionModel = this.arcHandleModel.pathInteractionModel;

    this.cameraModel = this.gui.editorModel.cameraModel();

    this.initGroups(parentGroup, [layers.interaction, layers.interactionControl], arcHandleModel);

    this.svgGroup = this.getGroupInfo(layers.interaction).svgGroup;
    this.controlGroup = this.getGroupInfo(layers.interactionControl).svgGroup;

    this.cameraModel.viewS.onChange(self, function(){
        if (self.arcHandleModel.isAlive()) self.gui.heavyHandler.scheduleHeavy('rebuild_view', self.drawIfNeeded, self, [], self);
    },10);
    this.arcHandleModel.coord.onChange(self, function(){
        if (self.arcHandleModel.isAlive()) self.gui.heavyHandler.scheduleHeavy('rebuild_view', self.drawIfNeeded, self, [], self);
    },10);
    this.segmentModel.isCircular.onChange(self, function(){
        if (self.arcHandleModel.isAlive()) self.gui.heavyHandler.scheduleHeavy('rebuild_view', self.drawIfNeeded, self, [], self);
    },10);
    this.segmentModel.infocus.onChange(self, function(){
        if (self.arcHandleModel.isAlive()) self.gui.heavyHandler.scheduleHeavy('rebuild_view', self.drawIfNeeded, self, [], self);
    },10);
    this.arcHandleModel.onDie({}, function(o){
        self.removeSvg();
        self.cameraModel.viewS.removeHandlers(self);
        self.arcHandleModel.coord.removeHandlers(self);
        self.segmentModel.infocus.removeHandlers(self);
    },101);

    this.drawIfNeeded();
};

lib_core.mixin(ArcCenterHandleView, editor_2d.DrawingElement);

module.exports = ArcCenterHandleView;


ArcCenterHandleView.prototype.drawIfNeeded = function () {
    if (this.arcHandleModel.isAlive()
        && this.segmentModel.infocus()
    ) {
        this.draw();
    } else {
        this.emptySvgGroups();
    }
};

ArcCenterHandleView.prototype.draw = function () {
    var self = this;

    $(this.svgGroup).empty();
    $(this.controlGroup).empty();

    var c = self.arcHandleModel.coord();

    var size = 10 / this.cameraModel.viewS();
    var stroke = 1 / this.cameraModel.viewS();

    var object = self.segmentModel.object;

    var theme = this.arcHandleModel.parent().parent().origin.theme;

    // this is the ellipse the arc is on
    var d = this.gui.svg.createPath();
    d.move(object.previous().endpoint().getX(), object.previous().endpoint().getY());
    d = d.arc(object.xRadius(), object.yRadius(),
        object.angle(),
        (object.largeArcFlag() ? 1 : 0),
        (object.sweepFlag() ? 1 : 0),
        object.endpoint().getX(), object.endpoint().getY(),
        false);
    // draw other side by using same sweep but opposite large arc flag
    d = d.arc(object.xRadius(), object.yRadius(),
        object.angle(),
        (!object.largeArcFlag() ? 1 : 0),
        (object.sweepFlag() ? 1 : 0),
        object.previous().endpoint().getX(), object.previous().endpoint().getY(),
        false);
    this.gui.svg.path(this.svgGroup, d, {
        'fill': 'none',
        'opacity': 0.5,
        'stroke' : colors.arcEllipse[theme],
        'strokeWidth' : stroke,
        'stroke-dasharray': size
    });

    // center handle rect
    this.gui.svg.rect(this.svgGroup,c.x-size/2,c.y-size/2,size,size,{
        'fill' : this.selected ? colors.handleFillSelected : colors.handleFill,
        'fillOpacity' : 0.5,
        'stroke' : colors.arcCenterHandleStroke,
        'strokeWidth' : stroke
    });

    var handle = this.gui.svg.rect(this.controlGroup, c.x - size / 2, c.y - size / 2, size, size);

    $(handle).mousedown(function (event) {
        return self.onMouseDown(event);
    });

    if(self.segmentModel.isCircular()) { // draw the line on which the center point moves
        // this is the perpendicular line that goes between A and B
        var mid = object.getEndpoint().add(object.previous().getEndpoint()).mult(0.5);
        var perpDir = object.getEndpoint().sub(object.previous().getEndpoint()).perp().norm();
        var perpVec = perpDir.mult(4*object.largeRadius());
        var p0 = mid.add(perpVec);
        var p1 = mid.sub(perpVec);
        this.gui.svg.line(this.svgGroup,
            p0.x, p0.y,
            p1.x, p1.y, {
                'stroke': colors.arcConstrainedMoveLine[theme],
                'strokeWidth': stroke,
                'opacity': 0.3
            }
        );
    }
};

ArcCenterHandleView.prototype.onMouseDown = function (event) {
    var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.ELEMENT_MOUSE_DOWN)
        .fromJSEvent(event)
        .element( this.arcHandleModel )
        .data( 'mouseCoord', this.gui.relativeMouseCoord(event) )
        .data( 'notFocusable', true );

    return this.gui.stateMachine.handle(cEvent);
};
